<template>
	<v-app>

		<LoginWatcher v-if="showLoginWatcher"
			:logout-redirect=config.defaultRedirect.logout
		/>

		<HeaderApp v-on:show-site-notification="showSiteNotification" />



		<v-content>

		<!-- Begin Site Notification Bar -->
		<v-alert v-if="false && config.linkToOldVersion"
			tile dense dismissible color="info" dark class="mb-0">
			<v-row dense>
				<v-col cols="12" md="6"  :class="{'text-right': !isMobile, 'text-center': isMobile}">
      		<v-icon class="mr-2">mdi-alert-circle</v-icon>{{ $t('articles.V3Annoucement.alertTxt') }}
      	</v-col>
      	<v-col cols="12" md="6" :class="{'text-left': !isMobile, 'text-center': isMobile}">
		      <v-btn @click="showSiteNotification()"
		      	small outlined color="white" class="ml-2">
		      	{{ $t('common.phrase.whatsNew') }}
		    	</v-btn>
		    	<v-btn href="https://app-v2.ledgerdex.com" target="_blank"
		      	small outlined color="white" class="ml-2">
		      	{{ $t('common.phrase.visitOldVersion') }}
		    	</v-btn>
		    </v-col>
		  </v-row>
    </v-alert>
		<!-- End Site Notificatio Bar -->

			<router-view
				:key="key"
				@successNotification="showSuccessNotification"
				@errorNotification="showErrorNotification"
			/>
		</v-content>

		<WalletWatcher
			v-if="showWalletWatcher"
			:wallet-not-connected-redirect=config.defaultRedirect.WalletNotConnected
			:chain-change-redirect=config.defaultRedirect.chainChange
			:account-change-redirect=config.defaultRedirect.accountChange
		/>

		<!-- -------------------------------- Begin Notification Bar ---------------------------------->
		<v-snackbar
			top
			:color="notificationBar.type"
			v-model="notificationBar.show"
		>
			{{ notificationBar.message }}
			<v-btn icon @click="notificationBar.show = false">
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-snackbar>
		<!-- -------------------------------- End Notification Bar ---------------------------------->

		<!-- Begin Site Notification -->
		<NotificationModal v-if="config.linkToOldVersion"
    	ref="siteNotification" :fullscreen="isMobile"
    	:title="$t('articles.V3Annoucement.title')"
    	:content="$t('articles.V3Annoucement.contents')"
  	/>
		<!-- End Site Notification -->

		<FooterApp />

	</v-app>
</template>



<script>
import { config } from '@/config'
import HeaderApp from "@/components/HeaderApp"
import FooterApp from "@/components/FooterApp"
import WalletWatcher from "@/components/WalletWatcher"
import LoginWatcher from "@/components/LoginWatcher"
import NotificationModal from "@/components/NotificationModal"
export default {
	components: {
		HeaderApp,
		FooterApp,
		WalletWatcher,
		LoginWatcher,
		NotificationModal
	},
	data: () => ({
		config: config,
		showNotification: false,
		notificationBar: {
			show: false,
			type: 'success', // 'success', 'error'
			message: ''
		},
	}),
	computed: {
		isMobile: function () {
      return this.$vuetify.breakpoint.xsOnly
    },
		showLoginWatcher: function () {
			return this.$router.currentRoute.name !== config.defaultRedirect.logout
		},
		showWalletWatcher: function () {
			return this.$router.currentRoute.name !== config.defaultRedirect.WalletNotConnected
			&& this.$router.currentRoute.name !== config.defaultRedirect.chainChange
			&& this.$router.currentRoute.name !== config.defaultRedirect.accountChange
			&& this.$router.currentRoute.name !== config.defaultRedirect.logout
		},
		key: function () {
			const now = (new Date()).getTime()
			return this.$route.name !== undefined
				? this.$route.name + '-' + now
				: this.$route + '-' + now
		},
	},
	methods: {
		showSuccessNotification: function (message) {
			// console.log('success: ' + message)
			this.notificationBar.message = message
			this.notificationBar.type = 'success'   // 'success' or 'error'
			this.notificationBar.show = true
		},
		showErrorNotification: function (message) {
			// console.log('error: ' + message)
			this.notificationBar.message = message
			this.notificationBar.type = 'error'   // 'success' or 'error'
			this.notificationBar.show = true
		},
		showSiteNotification() {
      this.$refs.siteNotification.showModal()
    },
	},
};
</script>

<style>
.main-content {
	max-width: 1024px;
	margin-left: auto;
	margin-right: auto;
}
</style>
